<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        :btitle="'Sip User Info'"
        :collapseStatus="'close'"
        style="height: 100%"
      >
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkAdd()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>
        <!--显示列表-->
        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllUserInfo"
                />
                <label for="idSelectAllUserInfo"></label>
              </th>
              <th
                v-for="(value, key) in uniqueSipUserInfo.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in uniqueSipUserInfo.data"
              :key="row.potsNum"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectUserInfo' + index"
                  />
                  <label :for="'idRowSelectUserInfo' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.potsNum }}</div>
              </td>
              <td>
                <div>{{ row.description }}</div>
              </td>
              <td>
                <div>{{ row.name }}</div>
              </td>
              <td>
                <div>{{ row.password }}</div>
              </td>
              <td>
                <div>{{ row.telno }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Sip User Info Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="potsNum"
                  >Pots Num</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'potsNum',
                      sipUserInfoForm.potsNum
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="potsNum"
                    :disabled="isEditClik"
                    v-model="sipUserInfoForm.potsNum"
                    placeholder="INTEGER<1-2>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'potsNum',
                        sipUserInfoForm.potsNum
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("potsNum", sipUserInfoForm.potsNum) }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="description"
                  >Description</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'description',
                      sipUserInfoForm.description
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="description"
                    v-model="sipUserInfoForm.description"
                    placeholder="STRING<1-25>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'description',
                        sipUserInfoForm.description
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters(
                        "description",
                        sipUserInfoForm.description
                      )
                    }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="name">Name</label>
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters('name', sipUserInfoForm.name),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    v-model="sipUserInfoForm.name"
                    placeholder="STRING<1-50>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('name', sipUserInfoForm.name)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("name", sipUserInfoForm.name) }}
                  </small>
                </div>
              </div>
              <div v-if="sipUserInfoForm.name != ''" class="form-group">
                <label class="col-sm-3 control-label" for="password"
                  >Password</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'password',
                      sipUserInfoForm.password
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="password"
                    v-model="sipUserInfoForm.password"
                    placeholder="STRING<1-25>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'password',
                        sipUserInfoForm.password
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("password", sipUserInfoForm.password) }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="telephoneNum"
                  >Telephone Number</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'telno',
                      sipUserInfoForm.telno
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="telephoneNum"
                    v-model="sipUserInfoForm.telno"
                    placeholder="STRING<1-25>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('telno', sipUserInfoForm.telno)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("telno", sipUserInfoForm.telno) }}
                  </small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "uniqueSipUserInfo",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  props: ["ontIndex"],

  data() {
    return {
      uniqueSipUserInfo: "",
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      sipUserInfoForm: {
        potsNum: "",
        description: "",
        name: "",
        password: "",
        telno: "",
      },
    }
  },

  created() {
    this.loaduniqueSipUserInfo()
  },

  methods: {
    loaduniqueSipUserInfo() {
      get("uniqueSipUserInfo?ontIndex=" + this.ontIndex)
        .then((res) => (this.uniqueSipUserInfo = res.data))
        .catch((err) => {})
    },

    clkAdd() {
      this.isShowAddTable = true
      this.isEditClik = false
      this.resetField()
      this.selectNull()
    },
    clkEdit() {
      for (let i = 0; i < this.uniqueSipUserInfo.data.length; i++) {
        if (this.uniqueSipUserInfo.data[i].selected) {
          this.sipUserInfoForm.potsNum = this.uniqueSipUserInfo.data[i].potsNum
          this.sipUserInfoForm.description =
            this.uniqueSipUserInfo.data[i].description
          this.sipUserInfoForm.name = this.uniqueSipUserInfo.data[i].name
          this.sipUserInfoForm.password =
            this.uniqueSipUserInfo.data[i].password
          this.sipUserInfoForm.telno = this.uniqueSipUserInfo.data[i].telno
          this.isShowAddTable = true
          this.isEditClik = true
          return
        }
      }
    },

    clkDel() {
      var delData = {}
      var list = []

      for (let i = 0; i < this.uniqueSipUserInfo.data.length; i++) {
        if (this.uniqueSipUserInfo.data[i].selected) {
          list.push({ num: Number(this.uniqueSipUserInfo.data[i].potsNum) })
        }
      }
      if (list.length == 0) {
        return
      }

      delData["pots"] = list
      delData["ontIndex"] = this.ontIndex
      post("uniqueSipUserInfoDelete", delData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loaduniqueSipUserInfo()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else {
            this.loaduniqueSipUserInfo()
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var sipUserInfoFormTmp = {
        potsNum: "",
        description: "",
        name: "",
        password: "",
        telno: "",
      }
      this.sipUserInfoForm = sipUserInfoFormTmp
    },
    changeSelectAll() {
      for (let i = 0; i < this.uniqueSipUserInfo.data.length; i++) {
        if (this.isSelectAll) {
          this.uniqueSipUserInfo.data[i].selected = true
        } else {
          this.uniqueSipUserInfo.data[i].selected = false
        }
      }
    },

    selectNull() {
      for (let i = 0; i < this.uniqueSipUserInfo.data.length; i++) {
        this.uniqueSipUserInfo.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var sipUserConfig = {
        ontIndex: this.ontIndex,
        potsNum: Number(this.sipUserInfoForm.potsNum),
        description: this.sipUserInfoForm.description,
        name: this.sipUserInfoForm.name,
        password: this.sipUserInfoForm.password,
        telno: this.sipUserInfoForm.telno,
      }
      if (this.isEditClik == false) {
        for (let i = 0; i < this.uniqueSipUserInfo.data.length; i++) {
          if (sipUserConfig.potsNum == this.uniqueSipUserInfo.data[i].potsNum) {
            this.showAlertBox(
              "warn",
              "Message",
              "This pots number has been created"
            )
            return
          }
        }
      }

      if (
        this.sipUserInfoForm.potsNum == "" ||
        this.checkParameters("potsNum", this.sipUserInfoForm.potsNum) ||
        this.sipUserInfoForm.telno == "" ||
        this.checkParameters("telno", this.sipUserInfoForm.telno) ||
        (this.sipUserInfoForm.description != "" &&
          this.checkParameters(
            "description",
            this.sipUserInfoForm.description
          )) ||
        (this.sipUserInfoForm.name != "" &&
          this.checkParameters("name", this.sipUserInfoForm.name)) ||
        (this.sipUserInfoForm.password != "" &&
          this.checkParameters("password", this.sipUserInfoForm.password)) ||
        (this.sipUserInfoForm.name == "" && this.sipUserInfoForm.password != "")
      ) {
        this.showAlertBox("warn", "Message", "Invalid parameters")
        return
      }

      post("uniqueSipUserInfoConfig", sipUserConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loaduniqueSipUserInfo()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.isEditClik = false
      this.selectNull()
    },
    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "potsNum") {
        if (isNaN(Number(value)) || Number(value) < 1 || Number(value) > 2) {
          return "pots number must be in range 1-2"
        }
      } else if (type == "description") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 25
        ) {
          return "invalid description"
        }
      } else if (type == "name") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 50
        ) {
          return "invalid name"
        }
      } else if (type == "password") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 25
        ) {
          return "invalid password"
        }
      } else if (type == "telno") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 25
        ) {
          return "invalid telephone number"
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
